import { formatPrice, mapProductTypeToProductCategory } from '@grandvisionhq/svc-tealium/utils';

const mapProductToTealiumProperties = (product)=>{
    var ref;
    const productTypeName = product.productType;
    let originalPrice = '';
    let discountedPrice = '';
    const price = (ref = product.masterVariant.pricing) === null || ref === void 0 ? void 0 : ref.price;
    if (price) {
        var ref1;
        originalPrice = formatPrice(price.originalPrice, price === null || price === void 0 ? void 0 : price.isCentAmount);
        var ref2;
        discountedPrice = formatPrice((ref2 = (ref1 = price.discount) === null || ref1 === void 0 ? void 0 : ref1.price) !== null && ref2 !== void 0 ? ref2 : price === null || price === void 0 ? void 0 : price.originalPrice, true);
    }
    const isLenses = productTypeName === 'Contact-lenses';
    const isProductWithAFrame = productTypeName === 'Frames' || productTypeName === 'Sunglasses' || productTypeName === 'Ready-readers';
    const productProperties = {
        Category: mapProductTypeToProductCategory(productTypeName),
        Price: discountedPrice,
        PriceFull: originalPrice,
        ModelName: isLenses ? product.name.en : product.masterVariant.name
    };
    if (isProductWithAFrame || isLenses) {
        productProperties.LensType = 'PLANO';
    }
    return productProperties;
};

export { mapProductToTealiumProperties };
//# sourceMappingURL=map-product-to-tealium-properties.js.map
